import { Visibility, VisibilityOff } from '@mui/icons-material';
import { Box, IconButton, Typography } from '@mui/material';
import React, { useState } from 'react';

type SecureTextProps = {
  text: string | null;
  typographyProps?: React.ComponentProps<typeof Typography>;
};

export const SecureText: React.FC<SecureTextProps> = ({
  text,
  typographyProps = {},
}) => {
  const [visible, setVisible] = useState(false);

  if (!text) return null;

  const handleVisibilityChange = () => {
    setVisible(!visible);
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Typography {...typographyProps}>
        {visible ? text : '•'.repeat(text.length)}
      </Typography>
      <IconButton
        className="cursor-pointer"
        onClick={handleVisibilityChange}
        sx={{ ml: 1, p: 0 }}
      >
        {visible ? (
          <VisibilityOff sx={{ fontSize: 16 }} />
        ) : (
          <Visibility sx={{ fontSize: 16 }} />
        )}
      </IconButton>
    </Box>
  );
};

export default SecureText;
